import React from "react";
import { Link } from "react-router-dom";
import {
  FaEnvelope,
  FaPhone,
  FaMapMarkerAlt,
  FaLinkedin,
  FaTwitter,
} from "react-icons/fa";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3 className="footer-logo">
              <span className="logo-highlight">Seagull Partners</span>
            </h3>
            <p className="footer-description">
              Smart growth solutions powered by data, technology, and strategic
              thinking.
            </p>
            <div className="footer-services">
              <span>✔ Data Intelligence</span>
              <span>✔ Digital Solutions</span>
              <span>✔ Business Growth Consulting</span>
            </div>
          </div>

          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul className="footer-links">
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>
                <Link to="/about">About Us</Link>
              </li>
              <li>
                <Link to="/why-seagull">Why Seagull</Link>
              </li>
              <li>
                <Link to="/solutions">Partner</Link>
              </li>
              <li>
                <Link to="/products-industries">Products & Industries</Link>
              </li>
              <li>
                <Link to="/contact">Contact</Link>
              </li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Contact Info</h4>
            <div className="contact-info">
              <div className="contact-item">
                <FaEnvelope className="contact-icon" />
                <span>info.seagullpartners@gmail.com</span>
              </div>
              <div className="contact-item">
                <FaPhone className="contact-icon" />
                <span>+(1) 3235540745</span>
              </div>
              <div className="contact-item">
                <FaMapMarkerAlt className="contact-icon" />
                <span>Frisco, TX 75034</span>
              </div>
            </div>
          </div>

          <div className="footer-section">
            <h4>Follow Us</h4>
            <div className="social-links">
              <a href="https://www.linkedin.com/company/seagullpartners/" target="blank_page" className="social-link">
                <FaLinkedin />
              </a>
              {/* <a href="#" className="social-link">
                <FaTwitter />
              </a> */}
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>
            &copy; Seagull Partners. All rights
            reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
